<app-cart *ngIf="!showProducts" [selectedCustomer]="selectedCustomer"
          [selectedProducts]="selectedProducts"
          [disableEdit]="disableEdit"
          [disableDelete]="disableEdit"
          [disableDraft]="disableEdit"
          (editRequested)="editOrder()"
          (cartUpdated)="onCartUpdated($event)"
          (placeOrderRequested)="placeOrder()"
          (saveAsDraftRequested)="saveAsDraft()"
          (deleteRequested)="deleteOrder()">
</app-cart>
<div *ngIf="showProducts" class="page-container">
  <app-product-list [selectedCustomer]="selectedCustomer!"
                    [selectedProducts]="selectedProducts"
                    (cartUpdated)="onCartUpdated($event)"
                    [products]="products">
  </app-product-list>

  <button mat-raised-button color="primary" class="sticky-button" (click)="showProducts = false" >
    Proceed
  </button>
</div>
